import Routes from "./Routes";
import "rsuite/dist/rsuite.min.css";

import Loader from "./layout/Loader";
import { useSelector } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { ModalProvider } from "./components/ModalContext";
import { ModalProviderRsuite } from "./components/ModalRsuiteContext";
import IModal from "./components/IModal";
import IModalRsuit from "./components/IModalRsuit";
import JsonView from "@uiw/react-json-view";

function wait(show) {
  var display = new Array();
  display[0] = "none";
  display[1] = "block";
  document.getElementById("ajax_notification").style.display = display[show];
}

function loader(show) {
  var display = new Array();
  display[0] = "none";
  display[1] = "block";
  document.getElementById("loader-center").style.display = display[show];
}

function jsonv(data) {
  return <JsonView value={data} />;
}
function App() {
  window.wait = wait;
  window.loader = loader;
  window.jsonv = jsonv;
  const { isLoggedIn, isLoading } = useSelector((state) => state.global);

  return (
    <>
      <div className="ajax_notification" id="ajax_notification">
        Please wait...
      </div>
      <div id="loader-center">
        <div className="loader" />
      </div>
      <div className="roboto-thin">
        {isLoading ? (
          <Loader />
        ) : (
          <ModalProvider>
            <ModalProviderRsuite>
              <Routes />
              <IModal />
              <IModalRsuit />
            </ModalProviderRsuite>
          </ModalProvider>
        )}
      </div>
    </>
  );
}

export default App;
